var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heatmapwrapper"},[_c('BubbleComponent',{attrs:{"data":{ datasets: [{ labels: _vm.labels, data: _vm.chartdata }]},"options":_vm.bubbleOptions,"plugins":_vm.plugins}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }